/* Bryce Hardware v3 — interactions */

/* Accordion toggles.
 *
 * The state is carried by a class on .acc, which a sighted user reads from the
 * +/- glyph and the panel moving. A screen reader got nothing: 461 of these
 * across 45 pages had no aria-expanded and no aria-controls, so the control
 * announced as "Specifications, button" with no indication it was collapsed,
 * and no confirmation when it opened. Behind them sit the spec table, the duct
 * dimensions, Install, Care and Shipping & returns.
 *
 * Wired here rather than in the markup because the same pattern is pasted into
 * every Field Guide article body, which the theme cannot edit.
 */
document.querySelectorAll('.acc-toggle').forEach((btn, i) => {
  const item = btn.closest('.acc');
  const panel = item ? item.querySelector('.acc-content') : null;

  if (panel) {
    if (!panel.id) panel.id = 'acc-panel-' + (i + 1);
    btn.setAttribute('aria-controls', panel.id);
  }
  btn.setAttribute('aria-expanded', item && item.classList.contains('open') ? 'true' : 'false');

  btn.addEventListener('click', () => {
    if (!item) return;
    const open = item.classList.toggle('open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
});

// PDP gallery — main image, thumb swap with fade
const mainImg = document.getElementById('mainImg');

function swapMain(src) {
  if (!mainImg || !src || mainImg.src === src) return;
  mainImg.style.opacity = '0.4';
  const tmp = new Image();
  tmp.onload = () => {
    mainImg.src = src;
    mainImg.style.opacity = '1';
  };
  tmp.src = src;
}

if (mainImg) {
  // Thumbnail click → main image swap
  document.querySelectorAll('.gthumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.gthumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const src = thumb.dataset.img;
      if (src) swapMain(src);
    });
  });
}

// PDP qty stepper + live ATC price + size-variant price/image swap
const qtyVal = document.getElementById('qtyVal');
const qtyMinus = document.getElementById('qtyMinus');
const qtyPlus = document.getElementById('qtyPlus');
const atcPrice = document.getElementById('atcPrice');
const priceEl = document.getElementById('priceDisplay');
let UNIT_PRICE = priceEl
  ? parseFloat(priceEl.dataset.unitPrice || priceEl.textContent.replace(/[^0-9.]/g, '') || '0')
  : 0;

function fmt(n) { return '$' + n.toFixed(2); }

/* Offer meter: how far this order sits from the two standing offers.
 *
 * Both are automatic Shopify discounts, so the page has to show the same
 * numbers checkout will. The volume discount comes off first and the free
 * shipping threshold is tested against what is left, which is the order
 * Shopify applies them in. Rendered server-side for quantity 1 (crawlers do
 * not run this file); from here it follows the stepper and the size chips. */
const meter = document.querySelector('.offer-meter');
const MIN_QTY  = meter ? parseInt(meter.dataset.volQty, 10) : 0;
const VOL_PCT  = meter ? parseInt(meter.dataset.volPct, 10) : 0;
const FREE_OVER = meter ? parseFloat(meter.dataset.freeOver) : 0;

function updateMeter(q, subtotal) {
  if (!meter) return;
  const dots = meter.querySelectorAll('.offer-dots .dot');
  const volText = meter.querySelector('[data-offer="volume"]');
  const shipText = meter.querySelector('[data-offer="ship"]');
  const bar = meter.querySelector('.offer-bar span');

  dots.forEach((d, i) => d.classList.toggle('on', i < q));
  meter.classList.toggle('vol-met', q >= MIN_QTY);

  const need = MIN_QTY - q;
  if (volText) {
    volText.textContent = need > 0
      ? `${need} more item${need === 1 ? '' : 's'} and ${VOL_PCT}% comes off the ` +
        'order. Any sizes, any products.'
      : `${VOL_PCT}% off, already in the total. ${MIN_QTY} items or more, any mix.`;
  }

  const short = FREE_OVER - subtotal;
  meter.classList.toggle('ship-met', short <= 0);
  if (shipText) {
    shipText.textContent = short > 0
      ? `${fmt(short)} more for free standard US shipping.`
      : 'Free standard US shipping.';
  }
  if (bar) bar.style.width = Math.min(100, subtotal / FREE_OVER * 100).toFixed(1) + '%';
}

/* The stepper's number lives in a <span>, but what actually gets posted is the
   hidden <input name="quantity"> in the buy form. Nothing kept the two in step,
   so the page would read "Add to cart $37.77" for three at the volume price and
   then put ONE in the cart at $13.99. Write the input every time the number
   changes. */
function syncQtyInput(q) {
  const input = document.querySelector('#bryce-product-form [name="quantity"]');
  if (input) input.value = q;
}

function updateATC() {
  if (!qtyVal || !atcPrice) return;
  const q = parseInt(qtyVal.textContent, 10);
  syncQtyInput(q);
  /* Shopify discounts in integer cents and floors; doing it in floats here put
     the button a cent under what the cart charged at qty 3+ ($43.17 vs $43.18). */
  const cents = Math.round(UNIT_PRICE * 100) * q;
  const disc = q >= MIN_QTY ? Math.floor(cents * VOL_PCT / 100) : 0;
  const subtotal = (cents - disc) / 100;
  atcPrice.textContent = fmt(subtotal);
  updateMeter(q, subtotal);
}

if (qtyMinus && qtyPlus && qtyVal) {
  qtyMinus.addEventListener('click', () => {
    const q = Math.max(1, parseInt(qtyVal.textContent, 10) - 1);
    qtyVal.textContent = q;
    updateATC();
  });
  qtyPlus.addEventListener('click', () => {
    const q = Math.min(99, parseInt(qtyVal.textContent, 10) + 1);
    qtyVal.textContent = q;
    updateATC();
  });
}

// Chip group selection (size, finish, pack)
document.querySelectorAll('.chip-row').forEach(row => {
  row.querySelectorAll('.chip').forEach(chip => {
    chip.addEventListener('click', () => {
      if (chip.classList.contains('disabled')) return;
      row.querySelectorAll('.chip').forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
      const section = chip.closest('.pinfo-section');
      if (section) {
        const label = section.querySelector('.selected');
        if (label) label.textContent = chip.textContent.trim();
      }

      // Swap the whole gallery when a size carries its own image set.
      // Each size is photographed separately (the packaging in every shot shows
      // that size's dimensions), so the thumbs have to follow the selection —
      // not just the main image.
      if (chip.dataset.gallery) {
        rebuildGallery(chip.dataset.gallery.split('|'), chip.textContent.trim());
      } else if (chip.dataset.img) {
        swapMain(chip.dataset.img);
      }

      // Keep the spec table's size-dependent rows in step with the selection.
      // These are the numbers somebody cuts a hole to, so showing the default
      // size's figures next to a different selected size is the one error on
      // this page that costs a customer real money.
      ['outer', 'open', 'door'].forEach(key => {
        const row = document.querySelector(`.spec-table tr[data-dim="${key}"] td`);
        const val = chip.dataset['dim' + key.charAt(0).toUpperCase() + key.slice(1)];
        if (row && val) row.textContent = val;
      });

      // Keep the visible UPC in step with the selected size
      if (chip.dataset.upc) {
        document.querySelectorAll('.spec-ids code').forEach(el => {
          if (/^\d{12}$/.test(el.textContent.trim())) el.textContent = chip.dataset.upc;
        });
      }

      // Update price + ATC if chip has a data-price
      if (chip.dataset.price) {
        const newPrice = parseFloat(chip.dataset.price);
        if (!isNaN(newPrice)) {
          UNIT_PRICE = newPrice;
          if (priceEl) priceEl.textContent = fmt(newPrice);
          updateATC();
        }
      }
    });
  });
});


// Rebuild the thumbnail strip for a newly selected size.
function rebuildGallery(urls, label) {
  // Keep the mobile swipe track in step with the thumbs.
  if (typeof window.bryceRebuildSwipe === 'function') window.bryceRebuildSwipe(urls, label);

  const strip = document.querySelector('.gallery-thumbs');
  if (!strip || !urls.length) return;

  swapMain(urls[0]);
  strip.innerHTML = urls.map((src, i) => `
        <button class="gthumb${i === 0 ? ' active' : ''}" data-img="${src}"
                aria-label="${label}, view ${i + 1} of ${urls.length}">
          <img src="${src}" alt="${label} view ${i + 1}" loading="lazy" decoding="async" />
        </button>`).join('');

  // Re-bind: the old thumb nodes are gone, so their listeners went with them.
  strip.querySelectorAll('.gthumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      strip.querySelectorAll('.gthumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (thumb.dataset.img) swapMain(thumb.dataset.img);
    });
  });
}

/* Review rating filter.
 *
 * Every review is already in the page source. The default view shows the 4 and
 * 5 star ones; clicking a rating row in the distribution filters to that
 * level. Standard ecommerce filtering, and it keeps the full set crawlable for
 * search engines and AI crawlers, which do not run this script. */
document.querySelectorAll('.rv-module').forEach(mod => {
  const cards = [...mod.querySelectorAll('.rv-card')];
  const rows  = [...mod.querySelectorAll('.rv-bar-row')];
  const note  = mod.querySelector('.rv-filter-note');
  const label = note && note.querySelector('span');
  const clear = mod.querySelector('.rv-clear');
  if (!cards.length || !rows.length) return;

  const TOP_LIMIT = 6;

  function apply(rating) {
    let shownTop = 0;
    cards.forEach(c => {
      const r = parseInt(c.dataset.rating, 10);
      let show;
      if (rating === 'top') {
        show = r >= 4 && shownTop < TOP_LIMIT;
        if (show) shownTop += 1;
      } else {
        show = r === rating;
      }
      c.hidden = !show;
    });
    rows.forEach(b => b.classList.toggle(
      'active', rating !== 'top' && parseInt(b.dataset.filter, 10) === rating));
    if (note) {
      note.hidden = rating === 'top';
      if (label && rating !== 'top') {
        const n = cards.filter(c => parseInt(c.dataset.rating, 10) === rating).length;
        label.textContent = `${n} review${n === 1 ? '' : 's'} at ${rating} star${rating === 1 ? '' : 's'}`;
      }
    }
    mod.dataset.rvFilter = rating;
  }

  rows.forEach(b => b.addEventListener('click', () => {
    const r = parseInt(b.dataset.filter, 10);
    apply(mod.dataset.rvFilter === String(r) ? 'top' : r);
  }));
  if (clear) clear.addEventListener('click', () => apply('top'));

  apply('top');
});

// Run once so the meter and the button agree with the pre-selected size.
updateATC();


/* ============================================================
   Collection / rail add-to-cart
   ------------------------------------------------------------
   The cards have carried `data-bryce-add="<variant id>"` since the port, but
   nothing ever bound it: bryce-app.js is the only script layout/theme.liquid
   loads, and it had no cart code. The button was inert everywhere, desktop
   included. (assets/quick-add.js is Dawn's own <quick-add-modal> element and
   is not loaded.)

   Add to cart rather than buy now, deliberately. Items run $5.49-$24.99 against
   a $49 free-shipping threshold and a 10%-off-any-3 discount, so sending one
   low-value item straight to checkout clears neither offer and bypasses the
   cart, which is where the offer meter does the upselling. Every product has
   exactly one variant (sizes are separate products), so a one-tap add from a
   card is unambiguous and needs no variant picker.

   Delegated from document so it covers cards rendered by any section, and
   markup swapped in later.
   ============================================================ */
(function () {
  var ADDED_MS = 1600;

  function setCount(n) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = n;
    });
    document.querySelectorAll('.cart-btn').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + n + ' items');
    });
  }

  function flash(btn, text, cls) {
    btn.textContent = text;
    btn.classList.remove('is-busy');
    btn.classList.add(cls);
    setTimeout(function () {
      btn.textContent = btn.dataset.label;
      btn.classList.remove(cls);
      btn.dataset.busy = '0';
    }, ADDED_MS);
  }

  /* Capture phase, and stopImmediatePropagation.
     Something else on the storefront was also claiming this click and doing a
     classic form POST to /cart/add, which adds the item but then lands the
     shopper on /cart — measured: Google Tag Manager logged form_start and
     form_submit on a button that is in no form. Listening in the bubble phase
     left that race unresolved. Capturing at the document means this handler
     runs before anything bound further down, and stopImmediatePropagation
     keeps it the only one that runs. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bryce-add]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var id = btn.getAttribute('data-bryce-add');
    if (!id || btn.dataset.busy === '1') return;

    /* Acknowledge the tap straight away. Measured on this store the add plus
       the cart re-read takes about two seconds, and until this was here the
       button sat unchanged for all of it: no spinner, no label change, nothing.
       A shopper reads that as "it did not work" and taps again, which is how
       you get accidental doubles. busy is set here, not in flash(), so the
       second tap is ignored for the whole round trip. */
    btn.dataset.busy = '1';
    btn.dataset.label = btn.dataset.label || btn.textContent;
    btn.textContent = 'Adding\u2026';
    btn.classList.add('is-busy');

    fetch(window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root + 'cart/add.js'
            : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed: ' + r.status);
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        flash(btn, 'Added ✓', 'is-added');
        document.dispatchEvent(new CustomEvent('bryce:cart-updated', { detail: cart }));
      })
      .catch(function () {
        // Never leave the shopper guessing: fall back to the product page.
        flash(btn, 'Try again', 'is-error');
      });
  }, true);
})();


/* ============================================================
   Product-page buy form
   ------------------------------------------------------------
   #bryce-product-form was a plain POST to /cart/add, so adding anything
   reloaded the page onto /cart and the shopper lost their place. Submit it over
   AJAX instead, so the behaviour matches the collection cards: stay put, update
   the header count, confirm on the button.

   FormData is read at submit time, so whatever the size picker last wrote into
   [name="id"] and whatever the stepper wrote into [name="quantity"] is what
   gets posted. No duplicate source of truth.
   ============================================================ */
(function () {
  var form = document.getElementById('bryce-product-form');
  if (!form) return;

  var btn = form.querySelector('.btn-atc');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!btn || btn.dataset.busy === '1') return;

    var label = btn.innerHTML;
    btn.dataset.busy = '1';
    btn.classList.add('is-busy');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || 'Could not add to cart');
          return j;
        });
      })
      .then(function () {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.querySelectorAll('.cart-btn').forEach(function (el) {
          el.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
        });
        btn.innerHTML = 'Added ✓';
        btn.classList.add('is-added');
        setTimeout(function () {
          btn.innerHTML = label;
          btn.classList.remove('is-added', 'is-busy');
          btn.dataset.busy = '0';
        }, 1600);
        document.dispatchEvent(new CustomEvent('bryce:cart-updated', { detail: cart }));
      })
      .catch(function (err) {
        // Sold out, or the variant went away. Say so rather than failing silent.
        btn.innerHTML = (err && err.message) ? err.message : 'Could not add';
        btn.classList.add('is-error');
        setTimeout(function () {
          btn.innerHTML = label;
          btn.classList.remove('is-error', 'is-busy');
          btn.dataset.busy = '0';
        }, 2200);
      });
  });
})();


/* ============================================================
   Product gallery — mobile swipe dots
   ------------------------------------------------------------
   The swipe track itself is pure CSS scroll-snap, so swiping works with this
   script disabled. All this adds is the position indicator: one dot per slide,
   highlighted from the scroll position, and tappable to jump.

   Kept out of rebuildGallery's way: when a size chip swaps the gallery, that
   function rewrites the thumbs, so the track and dots are rebuilt from the same
   list here rather than left pointing at the old size's photos.
   ============================================================ */
(function () {
  var track = document.querySelector('.gallery-swipe');
  var rail  = document.querySelector('.gswipe-dots');
  if (!track || !rail) return;

  function slides() { return track.querySelectorAll('.gswipe-slide'); }

  function buildDots() {
    var n = slides().length;
    rail.innerHTML = '';
    if (n < 2) return;
    for (var i = 0; i < n; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = i === 0 ? 'on' : '';
      b.setAttribute('aria-label', 'Go to image ' + (i + 1) + ' of ' + n);
      b.dataset.i = i;
      rail.appendChild(b);
    }
  }

  function current() {
    // Nearest slide to the track's centre, which is what scroll-snap settles on.
    var mid = track.scrollLeft + track.clientWidth / 2;
    var best = 0, bestD = Infinity;
    slides().forEach(function (s, i) {
      var c = s.offsetLeft + s.offsetWidth / 2;
      var dd = Math.abs(c - mid);
      if (dd < bestD) { bestD = dd; best = i; }
    });
    return best;
  }

  function sync() {
    var i = current();
    rail.querySelectorAll('button').forEach(function (b, j) {
      b.classList.toggle('on', j === i);
    });
  }

  var tick;
  track.addEventListener('scroll', function () {
    if (tick) return;
    tick = requestAnimationFrame(function () { tick = null; sync(); });
  }, { passive: true });

  rail.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    var s = slides()[+b.dataset.i];
    if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  });

  buildDots();

  // Rebuild when a size chip swaps the gallery.
  window.bryceRebuildSwipe = function (urls, label) {
    if (!urls || !urls.length) return;
    track.innerHTML = urls.map(function (src, i) {
      return '<div class="gswipe-slide"><img src="' + src + '" alt="' + label +
             ' view ' + (i + 1) + ' of ' + urls.length + '" loading="lazy" decoding="async"></div>';
    }).join('');
    track.scrollLeft = 0;
    buildDots();
  };
})();
